const paymentApplication = {
  // == Page header / verify flow ==
  'payment_application.page.title': 'Payment Application',
  'payment_application.page.logo.alt': 'TouchBistro logo',
  'payment_application.continue.body': 'Click the button below to access your payment application.',
  'payment_application.continue.header': 'Continue to Your Payment Application',
  'payment_application.continue.submit': 'Continue',
  'payment_application.continue.error.retry': 'We could not reach the server. Please try again.',
  'payment_application.verify.header': 'Request a New Access Link',
  'payment_application.verify.body':
    'Your previous application link may have expired, already been used, or your session may have been interrupted.',
  'payment_application.verify.body_secondary':
    "Enter the email address associated with your application and we'll send you a new secure access link.",
  'payment_application.verify.body_warning':
    'Requesting a new link will invalidate any previously issued links.',
  'payment_application.verify.illustration.alt':
    'Illustration of a server holding a payment terminal and a customer holding a credit card at a restaurant',
  'payment_application.verify.field.email.label': 'Email',
  'payment_application.verify.submit': 'Submit',
  'payment_application.verify.success.header': 'Check your email',
  'payment_application.verify.success.body':
    'If an account is associated with the email address you entered, you will receive an email with a new secure link to access your payment application.',
  'payment_application.verify.success.body_secondary':
    'For security purposes, any previously issued links are now invalid.',
  'payment_application.verify.success.close': 'Close',
  'payment_application.footer.support_text':
    'If you have any questions please contact our professional services team:',
  'payment_application.footer.phone.label': 'T',
  'payment_application.footer.email.label': 'E',
  'payment_application.stepper.aria_label': 'Payment application progress',
  'payment_application.stepper.business_details': 'Business Details',
  'payment_application.stepper.business_owners': 'Business Owners',
  'payment_application.stepper.banking_details': 'Banking Details',
  'payment_application.stepper.portal_account_setup': 'Portal Account Set Up',
  'payment_application.stepper.review_and_submit': 'Review & Submit',

  // == Intro Page ==
  'payment_application.intro.header.title': 'Before we get started',
  'payment_application.intro.header.body':
    'To apply for TouchBistro Payments, powered by <strong>Payrix</strong>, you must provide details about your business, ownership structure, and bank account.',
  'payment_application.intro.header.note':
    "This application must be <strong>completed in one sitting</strong>, since it <strong>can't be saved partway</strong>, and will take approximately <strong>15 minutes</strong>. It's available on <strong>desktop only</strong>.",
  'payment_application.intro.checklist.header': 'Please have the following handy before you begin:',
  'payment_application.intro.checklist.ein': 'Your <strong>EIN/IRS</strong> assignment letter',
  'payment_application.intro.checklist.formation_document':
    'Your <strong>formation document</strong>',
  'payment_application.intro.checklist.bank_proof':
    'A <strong>void check</strong>, a <strong>bank statement</strong>, or a <strong>bank letter</strong>',
  'payment_application.intro.checklist.owners':
    'A <strong>Social Security Number</strong> and contact details for <strong>all owners</strong> with <strong>25%</strong> or more ownership',
  'payment_application.intro.cta.get_started': 'Get Started',
  'payment_application.intro.illustration.alt':
    'Illustration of a person carrying a folder up steps next to abstract shapes',
  // == Business Details Page ==
  'payment_application.business_details.header.title': 'Business Details',
  'payment_application.business_details.header.body':
    'Help us understand your business so we can process your payment account properly. This section focuses on the basics we need to get you started.',
  // Business Name section
  'payment_application.business_details.business_name.section': 'Business Name',

  // Legal Business Name
  'payment_application.business_details.legal_business_name.label': 'Legal Business Name',
  'payment_application.business_details.legal_business_name.placeholder':
    'Enter your legal business name',
  'payment_application.business_details.legal_business_name.helper':
    "Name must match exactly as it is written in the EIN/IRS assignment letter. Sole Proprietorships use the Owner's name as the legal business name.",

  // Doing Business As
  'payment_application.business_details.doing_business_as.label': '"Doing Business As" Name',
  'payment_application.business_details.doing_business_as.placeholder':
    'Enter "Doing business as" name',
  'payment_application.business_details.doing_business_as.helper':
    "This is what will display on the customer's card statement.",

  // Business Operations section
  'payment_application.business_details.business_operations.section': 'Business Operations',

  // Industry
  'payment_application.business_details.industry.label': 'Industry',
  'payment_application.business_details.industry.placeholder': 'Select one',
  'payment_application.business_details.industry.helper':
    'Select the option that most accurately reflects the services you offer.',

  // Payment Method
  'payment_application.business_details.payment_method.label':
    'How does your business primarily take payments?',
  'payment_application.business_details.payment_method.placeholder': 'Select one',

  // Batch Time
  'payment_application.business_details.batch_time.label': 'Batch Time',
  'payment_application.business_details.batch_time.placeholder': 'Select one',
  'payment_application.business_details.batch_time.helper':
    "Set the date time your network's batch transactions will auto-close for settlement.",

  // Expected Annual Volume
  'payment_application.business_details.expected_annual_volume.label':
    'Expected Annual Processing Volume',
  'payment_application.business_details.expected_annual_volume.placeholder': 'XX,XXX,XXX',
  'payment_application.business_details.expected_annual_volume.prefix': 'USD\u00a0$',
  'payment_application.business_details.expected_annual_volume.suffix': '/\u00a0annually',
  'payment_application.business_details.expected_annual_volume.helper':
    'Annual amount of expected volume processed only through TouchBistro Payments (not total sales). For CNP-only customers, enter only the expected amount for this category (without including CNP).',

  // Expected Average Transaction
  'payment_application.business_details.expected_average_transaction.label':
    'Expected Average Transaction Amount',
  'payment_application.business_details.expected_average_transaction.placeholder': 'XXXX',
  'payment_application.business_details.expected_average_transaction.prefix': 'USD\u00a0$',
  'payment_application.business_details.expected_average_transaction.helper':
    'Average sale amount in the previous year. For a new business, provide an estimate of what this will be.',

  // Processing Description
  'payment_application.business_details.processing_description.label':
    'What does your business process payments for, and how are goods sold?',
  'payment_application.business_details.processing_description.placeholder':
    'e.g. Brunch food and drinks at our restaurant',

  // Business Registration section
  'payment_application.business_details.business_registration.section': 'Business Registration',

  // Business Type
  'payment_application.business_details.business_type.label': 'Business Type',
  'payment_application.business_details.business_type.placeholder': 'Select one',
  'payment_application.business_details.business_type.helper':
    'Select the option that matches what is on your business registration documents with the Secretary of State.',

  // TIN Type
  'payment_application.business_details.tin_type.label': 'TIN Type',
  'payment_application.business_details.tin_type.placeholder': 'Select one',

  // EIN
  'payment_application.business_details.ein.label': 'EIN',
  'payment_application.business_details.ein.placeholder': '9 digit EIN',
  'payment_application.business_details.ein.helper':
    "Found on your IRS letter. For Sole Proprietorships, enter the Owner's SSN if no EIN was issued.",
  'payment_application.business_details.ein.tooltip':
    'Your 9-digit Employer Identification Number issued by the IRS.',

  // Date Established
  'payment_application.business_details.date_established.label': 'Date Business Established',
  'payment_application.business_details.date_established.placeholder': 'MM/DD/YYYY',

  // Is Public Company
  'payment_application.business_details.is_public_company.label': 'Is this a Public Company?',
  'payment_application.business_details.is_public_company.placeholder': 'Select one',

  // Business Contact section
  'payment_application.business_details.business_contact.section': 'Business Contact Information',

  // Business Phone
  'payment_application.business_details.business_phone.label': 'Business Phone Number',
  'payment_application.business_details.business_phone.helper': 'Enter a 10 digit phone number.',

  // Customer Service Phone
  'payment_application.business_details.customer_service_phone.label':
    'Customer Service Phone Number',
  'payment_application.business_details.customer_service_phone.helper':
    "Enter the phone number used by the customer's card statement. If none is provided, the Business Phone Number will be displayed.",

  // Business Email
  'payment_application.business_details.business_email.label': 'Business Email',
  'payment_application.business_details.business_email.placeholder': 'example@email.com',

  // Business Website
  'payment_application.business_details.business_website.label': 'Business Website',
  'payment_application.business_details.business_website.placeholder': 'yourwebsite.com',
  'payment_application.business_details.business_website.helper':
    'Partner websites or generic websites used for multiple merchants are not permitted.',
  'payment_application.business_details.business_website.no_website': 'No website',

  // Business Address section
  'payment_application.business_details.business_address.section': 'Business Address',

  // Address Line 1
  'payment_application.business_details.address_line_1.label': 'Address Line 1',
  'payment_application.business_details.address_line_1.placeholder': 'Enter your street address',
  'payment_application.business_details.address_line_1.helper':
    'Enter the business address where the business is conducted. PO Boxes, public shared office spaces, & forwarding services addresses will not be accepted.',

  // Address Line 2
  'payment_application.business_details.address_line_2.label': 'Address Line 2',
  'payment_application.business_details.address_line_2.placeholder': 'Apartment, floor, building',

  // City
  'payment_application.business_details.city.label': 'City',
  'payment_application.business_details.city.placeholder': 'Enter your city',

  // State
  'payment_application.business_details.state.label': 'State',
  'payment_application.business_details.state.placeholder': 'Select one',

  // Zip Code
  'payment_application.business_details.zip_code.label': 'Zip Code',
  'payment_application.business_details.zip_code.placeholder': 'XXXXX',

  // Validation
  'payment_application.business_details.validation.required': 'This field is required',
  'payment_application.business_details.validation.email': 'Enter a valid email address',
  'payment_application.business_details.validation.url': 'Enter a valid website URL',
  'payment_application.business_details.validation.ein': 'Enter a valid 9-digit EIN',
  'payment_application.business_details.validation.zip': 'Enter a valid 5-digit ZIP code',

  // CTA
  'payment_application.business_details.cta.next_step': 'Next Step',

  // == Business Owners Page ==
  'payment_application.business_owners.header.title': 'Business Owners',
  'payment_application.business_owners.header.body':
    "Tell us about the individuals who own 25% or more of your business. We're required to collect this information to verify and process your application. You can also include owners with smaller shares if it adds clarity.",

  'payment_application.business_owners.info.title': 'Owner {{index}} Information',
  'payment_application.business_owners.info.body':
    "Enter owner's information exactly as it appears on government issued documents.",
  'payment_application.business_owners.address.title': 'Owner {{index}} Address',
  'payment_application.business_owners.field.primary_owner.label': 'Primary owner',
  'payment_application.business_owners.field.first_name.label': 'First Name',
  'payment_application.business_owners.field.first_name.placeholder': "Enter owner's first name",
  'payment_application.business_owners.field.middle_name.label': 'Middle Name',
  'payment_application.business_owners.field.middle_name.placeholder': "Enter owner's middle name",
  'payment_application.business_owners.field.last_name.label': 'Last Name',
  'payment_application.business_owners.field.last_name.placeholder': "Enter owner's last name",
  'payment_application.business_owners.field.ownership_percentage.label': 'Ownership Percentage',
  'payment_application.business_owners.field.business_phone.label': 'Business Phone Number',
  'payment_application.business_owners.field.email_address.label': 'Email Address',
  'payment_application.business_owners.field.email_address.placeholder': 'example@email.com',
  'payment_application.business_owners.field.country.label': 'Country',
  'payment_application.business_owners.field.date_of_birth.label': 'Date of Birth',
  'payment_application.business_owners.field.date_of_birth.placeholder': 'MM/DD/YYYY',
  'payment_application.business_owners.field.social_security_number.label':
    'Social Security Number',
  'payment_application.business_owners.field.social_security_number.placeholder':
    'e.g. 111 - 11 - 1111',
  'payment_application.business_owners.field.social_security_number.helper':
    "• If you don't have an SSN, an ITIN can be entered. However the business must have an EIN, the bank account must be from US and TouchBistro will reach out if further documentation is required.\n• If you are not a US resident and don't have ITIN, you can submit your passport number, and TouchBistro will reach out if further documentation is required.",
  'payment_application.business_owners.field.business_title.label': 'Business Title',
  'payment_application.business_owners.field.business_title.placeholder':
    'e.g. CEO, Director, Owner',
  'payment_application.business_owners.field.business_title.helper': 'Your role in the company.',
  'payment_application.business_owners.field.address_line_1.label': 'Address 1',
  'payment_application.business_owners.field.address_line_1.placeholder':
    'Enter your street address',
  'payment_application.business_owners.field.address_line_1.helper':
    'Enter the physical venue address where the business is conducted. No PO Boxes, public shared office spaces, and forwarding services addresses.',
  'payment_application.business_owners.field.address_line_2.label': 'Address 2',
  'payment_application.business_owners.field.address_line_2.placeholder':
    'Apartment, floor, building',
  'payment_application.business_owners.field.city.label': 'City',
  'payment_application.business_owners.field.city.placeholder': 'Enter your city',
  'payment_application.business_owners.field.state.label': 'State',
  'payment_application.business_owners.field.state.placeholder': 'Select one',
  'payment_application.business_owners.field.zip_code.label': 'Zip Code',
  'payment_application.business_owners.field.zip_code.placeholder': 'XXXXX',
  'payment_application.business_owners.cta.next_step': 'Next Step',
  'payment_application.business_owners.cta.add_owner': 'Add Another Owner',
  'payment_application.business_owners.cta.save_owner': 'Save Owner',
  'payment_application.business_owners.cta.cancel': 'Cancel',
  'payment_application.business_owners.cta.edit': 'Edit',
  'payment_application.business_owners.cta.remove': 'Remove',
  'payment_application.business_owners.summary.primary_tag': '(Primary)',
  'payment_application.business_owners.summary.ownership': '{{percentage}}% ownership',

  // == Banking Details Page ==
  'payment_application.banking_details.header.title': 'Banking Details',
  'payment_application.banking_details.header.body':
    "Add the bank account where you'd like to receive your deposits.",
  'payment_application.banking_details.header.body_extra':
    'Any future changes to your banking information require validation with a void cheque, bank letter, or statement, and the account must belong to the business or business owner. Otherwise, deposits may be held.',
  'payment_application.banking_details.section.bank_information': 'Enter Your Bank Information',
  'payment_application.banking_details.bank_information_disclaimer':
    'By providing this banking information, you are attesting this bank account belongs to this merchant and is under the name of the account holder or merchant with the financial institution.',
  'payment_application.banking_details.illustration.alt':
    'Sample US cheque highlighting routing number, account number, and check number',
  'payment_application.banking_details.field.account_type.label': 'Account Type',
  'payment_application.banking_details.field.account_type.placeholder': 'Select one',
  'payment_application.banking_details.field.routing_number.label': 'Routing Number',
  'payment_application.banking_details.field.routing_number.placeholder':
    'Routing number for the business bank account',
  'payment_application.banking_details.field.routing_number.helper':
    'Routing number for the business bank account.',
  'payment_application.banking_details.field.account_number.label': 'Account Number',
  'payment_application.banking_details.field.account_number.placeholder': 'e.g. 123456789012345',
  'payment_application.banking_details.field.account_number.helper':
    'Account number for the business bank account.',
  'payment_application.banking_details.field.confirm_account_number.label':
    'Confirm Account Number',
  'payment_application.banking_details.field.confirm_account_number.placeholder':
    'e.g. 123456789012345',

  // == Portal Account ==
  'payment_application.portal_account.header.title': 'Portal Account Set Up',
  'payment_application.portal_account.header.body':
    'Create your Payrix Portal login to access transaction reporting, dispute management, and monthly statements.',
  'payment_application.portal_account.section.create_user_account': 'Create a User Account',
  'payment_application.portal_account.section_body':
    'Create a username and password to access the Payrix Portal. You can create additional users later on from the Payrix Portal. An email confirmation link will be sent to the email provided. Confirmation of the account is required prior to account activation.',
  'payment_application.portal_account.field.username.label': 'Username',
  'payment_application.portal_account.field.username.placeholder': 'Text',
  'payment_application.portal_account.field.username.helper':
    '• Must include at least 1 number and 1 letter',
  'payment_application.portal_account.field.email_address.label': 'Email Address',
  'payment_application.portal_account.field.email_address.placeholder': 'example@email.com',
  'payment_application.portal_account.field.password.label': 'Password',
  'payment_application.portal_account.field.password.placeholder': 'Text',
  'payment_application.portal_account.field.password.helper_format':
    '• Must include 1 number, 1 uppercase letter, and 1 lowercase letter',
  'payment_application.portal_account.field.password.helper_length':
    '• Must be at least 8 characters long',
  'payment_application.portal_account.field.confirm_password.label': 'Confirm Password',
  'payment_application.portal_account.field.confirm_password.placeholder': 'Text',
  'payment_application.portal_account.validation.username_format':
    'Username must include at least 1 number and 1 letter',
  'payment_application.portal_account.validation.password_format':
    'Password must include 1 number, 1 uppercase letter, and 1 lowercase letter',
  'payment_application.portal_account.validation.password_length':
    'Password must be at least 8 characters long',
  'payment_application.portal_account.validation.passwords_match':
    'Passwords must match. Please check both fields.',

  // == Generic CTAs ==
  'payment_application.cta.back': 'Back',
  'payment_application.cta.next': 'Next Step',

  // == Dropdown enum translations ==

  // MerchantCategoryCode
  'payment_application.enum.merchant_category_code.5811.label': 'Caterers',
  'payment_application.enum.merchant_category_code.5811.description':
    'Food preparation and delivery for events, parties, and private functions.',
  'payment_application.enum.merchant_category_code.5812.label': 'Eating places and Restaurants',
  'payment_application.enum.merchant_category_code.5812.description':
    'Full-service restaurants where customers order, are served, and pay at the table.',
  'payment_application.enum.merchant_category_code.5813.label':
    'Drinking Places (Alcoholic Beverages), Bars, Taverns, Cocktail lounges, Nightclubs and Discotheques',
  'payment_application.enum.merchant_category_code.5813.description':
    'Bars, taverns, cocktail lounges, nightclubs, and discotheques whose primary sales are alcoholic beverages.',
  'payment_application.enum.merchant_category_code.5814.label': 'Fast Food Restaurants',
  'payment_application.enum.merchant_category_code.5814.description':
    'Quick-service restaurants where customers order at a counter or kiosk and food is prepared rapidly.',

  // MerchantEnvironment
  'payment_application.enum.merchant_environment.INVENUE.label': 'In Venue',
  'payment_application.enum.merchant_environment.ONLINE.label': 'Online',
  'payment_application.enum.merchant_environment.INVENUE_AND_ONLINE.label':
    'Both In Venue and Online',
  'payment_application.enum.merchant_environment.MANUALLY_KEYED.label': 'Manually Keyed',

  // BusinessType
  'payment_application.enum.business_type.SOLE_PROPRIETORSHIP.label': 'Sole Proprietorship',
  'payment_application.enum.business_type.CORPORATION.label': 'Corporation',
  'payment_application.enum.business_type.LIMITED_LIABILITY_COMPANY.label':
    'Limited Liability Company',
  'payment_application.enum.business_type.PARTNERSHIP.label': 'Partnership',
  'payment_application.enum.business_type.NON_PROFIT_CORPORATION.label': 'Non-Profit Corporation',

  // TinType
  'payment_application.enum.tin_type.SSN.label': 'SSN',
  'payment_application.enum.tin_type.TIN.label': 'EIN',
  'payment_application.enum.tin_type.OTHER.label': 'Other',

  // IsPublicCompany
  'payment_application.enum.is_public_company.YES.label': 'Yes',
  'payment_application.enum.is_public_company.NO.label': 'No',

  // AccountType
  'payment_application.enum.account_type.CHEQUING.label': 'Chequing',
  'payment_application.enum.account_type.SAVINGS.label': 'Savings',
  'payment_application.enum.account_type.BUSINESS_CHEQUING.label': 'Business Chequing',
  'payment_application.enum.account_type.BUSINESS_SAVINGS.label': 'Business Savings',

  // == Review (Step 5) ==
  'payment_application.review.header.title': 'Review & Submit',
  'payment_application.review.header.body':
    'Take a moment to confirm everything looks correct before you submit your application.',
  'payment_application.review.section.owners': 'Owners',
  'payment_application.review.subsection.user_account': 'User Account',
  'payment_application.review.subsection.bank_information': 'Bank Information',
  'payment_application.review.edit.business_details': 'Edit Business Details',
  'payment_application.review.edit.owner': 'Edit Owner {{index}}',
  'payment_application.review.edit.portal_account': 'Edit Portal Account Set Up',
  'payment_application.review.edit.banking_details': 'Edit Banking Details',
  'payment_application.review.consent':
    'I have read and agree to the <bankLink>Bank Disclosure Page</bankLink> and <termsLink>Merchant Terms and Conditions</termsLink>, and I attest that the information in this application is correct to the best of my knowledge.',
  'payment_application.review.cta.submit': 'Submit',
}

export default paymentApplication
